import { Button, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { Book, DollarSign, Info, List, MinusCircle, Plus, Repeat } from "react-feather";

export const MenuOptions = ({ params, Actions }) => {
  const { idcredito} = params.data;

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const {handleClickShowLogBook, handleClickShowExpenses, handleClickGPSRenewal} = Actions

  return (
    <>
      <Button 
        startIcon = { <List/>}
        variant='contained'
        size='small' 
        color='success'
        sx={{ marginRight: '8px' }}
        onClick={handleMenuOpen} 
        style={ { width: 150 } }
        > 
        Opciones
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        // sx={{
        //   position: 'absolute',
        //   zIndex: 2000, // Asegura visibilidad
        // }}
        // MenuListProps={{
        //   'aria-labelledby': 'basic-button',
        // }}
      >
        <MenuItem 
          onClick={()=>{
            handleClickShowLogBook(idcredito)
            handleMenuClose()
          }}
        >
          <ListItemIcon> <Book color="black"/> </ListItemIcon>
          <ListItemText primary="Bitacora" />
        </MenuItem>

        <MenuItem 
          onClick={() => {
            handleClickShowExpenses(idcredito)
            handleMenuClose()
          }}
        >
          <ListItemIcon> <DollarSign color="black"/> </ListItemIcon>
          <ListItemText primary="Gastos Asociados" />
        </MenuItem>
        
      </Menu>
    </>
  );
};
